import React from "react";

export const Features = (props) => {
  return (
    <div id="features" className="text-center" style={{ overflow: "hidden" }}>
      <div className="container" style={{ padding: "0 15px" }}>
        <div
          className="col-md-10 col-md-offset-1 section-title"
          style={{
            padding: "0 15px",

            animation: "fadeIn 0.8s ease-out",
          }}
        >
          <h2>Features</h2>
        </div>
        <div className="row" style={{ margin: "0 -10px" }}>
          {props.data
            ? props.data.map((d, i) => (
                <div
                  key={`${d.title}-${i}`}
                  className="feature-item"
                  style={{
                    padding: "0 10px",
                    marginBottom: "20px",
                    animation: `fadeInUp 0.6s ease-out ${i * 0.15}s backwards`,
                  }}
                >
                  <div style={{}}>
                    <i
                      className={d.icon}
                      style={{
                        fontSize: "2.5rem",
                        color: "white",
                      }}
                    ></i>
                  </div>
                  <h3
                    style={{
                      wordWrap: "break-word",
                      overflowWrap: "break-word",
                      marginBottom: "15px",
                    }}
                  >
                    {d.title}
                  </h3>
                  <p
                    style={{
                      wordWrap: "break-word",
                      overflowWrap: "break-word",
                      fontSize: "0.9rem",
                      lineHeight: "1.6",
                    }}
                  >
                    {d.text}
                  </p>
                </div>
              ))
            : "Loading..."}
        </div>
        <div className="row" style={{ margin: "30px -10px 0" }}>
          {props.data2
            ? props.data2.map((d, i) => (
                <div
                  key={`${d.title}-${i}`}
                  className="feature-item"
                  style={{
                    padding: "0 10px",
                    marginBottom: "20px",
                    animation: `fadeInUp 0.6s ease-out ${
                      (i + (props.data?.length || 0)) * 0.15
                    }s backwards`,
                  }}
                >
                  <div>
                    <i
                      className={d.icon}
                      style={{
                        fontSize: "2.5rem",
                        color: "white",
                      }}
                    ></i>
                  </div>
                  <h3
                    style={{
                      wordWrap: "break-word",
                      overflowWrap: "break-word",
                      marginBottom: "15px",
                    }}
                  >
                    {d.title}
                  </h3>
                  <p
                    style={{
                      wordWrap: "break-word",
                      overflowWrap: "break-word",
                      fontSize: "0.9rem",
                      lineHeight: "1.6",
                    }}
                  >
                    {d.text}
                  </p>
                </div>
              ))
            : "Loading..."}
        </div>
      </div>

      <style>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        #features * {
          box-sizing: border-box;
        }
        
        .feature-item {
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }
        
        .feature-item:hover {
          transform: translateY(-5px);
        }
        
        /* Mobile: 1 feature per row */
        @media (max-width: 575px) {
          .feature-item {
            width: 100% !important;
            float: left !important;
          }
          
          #features h2 {
            font-size: 1.8rem !important;
          }
          
          #features h3 {
            font-size: 1.3rem !important;
          }
          
          #features p {
            font-size: 1rem !important;
          }
        }
        
        /* Small tablets: 2 features per row */
        @media (min-width: 576px) and (max-width: 767px) {
          .feature-item {
            width: 50% !important;
            float: left !important;
          }
          
          #features h3 {
            font-size: 1.2rem !important;
          }
          
          #features p {
            font-size: 0.95rem !important;
          }
        }
        
        /* Medium tablets: 3 features per row */
        @media (min-width: 768px) and (max-width: 991px) {
          .feature-item {
            width: 33.333% !important;
            float: left !important;
          }
        }
        
        /* Large screens and up: 3 features per row */
        @media (min-width: 992px) {
          .feature-item {
            width: 33.333% !important;
            float: left !important;
          }
        }
      `}</style>
    </div>
  );
};
